export const GIFT_LIST_DECORATIVE_IMAGE =
  '/assets/wedding-websites/gift-list/gift-list-decorative-4.png';
